import axios from 'axios';
import { PACKSTATION_TYPE } from 'commerce/scayle/constants';
import { errorWrapper } from 'commerce/utils/network';

export interface PackstationResponseType {
  distance: number;
  name: string;
  location: {
    keyword: string;
    keywordId: string;
  };
  place: {
    address: {
      addressLocality: string;
      postalCode: string;
      streetAddress: string;
    };
  };
}

export interface AddressFindRequest {
  streetWHouseNo?: string;
  zip?: string;
  city?: string;
}

export const getPackstation = (zip: string, countryCode: string) => {
  return errorWrapper(getPackstation.name, async () => {
    return axios.post('/api/find-address/v1/dhl-service-point/find', {
      countryCode: countryCode,
      postalCode: zip,
      locationType: PACKSTATION_TYPE,
    });
  });
};

export const getAddressSuggestions = (data: AddressFindRequest) => {
  return errorWrapper(getAddressSuggestions.name, async () => {
    return axios.post('/api/address-suggestion/v1/address/find', data);
  });
};

export const getAddressValidate = (data: AddressFindRequest) => {
  return errorWrapper(getAddressValidate.name, async () => {
    return axios.post('/api/address-suggestion/v1/address/validate', data);
  });
};

export const validateDhlPostNumber = (data: {
  firstname: string;
  lastname: string;
  postnumber: string;
}) => {
  return errorWrapper(validateDhlPostNumber.name, async () => {
    return axios.post('/api/find-address/v1/postnumber/validate', data);
  });
};
